import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, createBlock as _createBlock, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-dff1c8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-align-center" }
const _hoisted_2 = { class: "cm-ui-mr5" }
const _hoisted_3 = { class: "assist-dialog-container" }
const _hoisted_4 = { class: "header-info" }
const _hoisted_5 = { class: "info-line cm-ui-mr15" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "cm-ui-bold-txt" }
const _hoisted_8 = { class: "info-line" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "cm-ui-bold-txt" }
const _hoisted_11 = { class: "banner-line" }
const _hoisted_12 = { class: "banner-line" }
const _hoisted_13 = { class: "banner-line" }
const _hoisted_14 = { class: "banner-line" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "banner-line" }
const _hoisted_17 = {
  key: 2,
  class: "banner-line"
}
const _hoisted_18 = { class: "banner-line" }
const _hoisted_19 = { class: "banner-line" }
const _hoisted_20 = { class: "banner-line" }
const _hoisted_21 = {
  key: 0,
  class: "banner-box cm-ui-mb15 error"
}
const _hoisted_22 = {
  key: 0,
  class: "banner-line star"
}
const _hoisted_23 = {
  key: 1,
  class: "banner-line star"
}
const _hoisted_24 = {
  key: 2,
  class: "banner-line star"
}
const _hoisted_25 = {
  key: 1,
  class: "banner-box cm-ui-mb15 cm-ui-pl15"
}
const _hoisted_26 = { class: "banner-line star" }
const _hoisted_27 = { class: "banner-line star" }
const _hoisted_28 = { class: "banner-line star" }
const _hoisted_29 = {
  key: 2,
  class: "assist-type cm-ui-mb30"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  class: "triangle"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont cm-icon-right" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "cm-align-center" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = { class: "content cm-ui-ml10 cm-ui-mt5" }
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "cm-ui-mr5" }
const _hoisted_39 = { class: "desc" }
const _hoisted_40 = { class: "assist-status" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_42 = {
  key: 0,
  class: "blue-txt cm-ui-ml10"
}
const _hoisted_43 = {
  key: 1,
  class: "blue-txt cm-ui-ml10"
}
const _hoisted_44 = {
  key: 2,
  class: "yellow-txt cm-ui-ml10"
}
const _hoisted_45 = {
  key: 3,
  class: "green-txt cm-ui-ml10"
}
const _hoisted_46 = {
  key: 4,
  class: "green-txt cm-ui-ml10"
}
const _hoisted_47 = {
  key: 5,
  class: "green-txt cm-ui-ml10"
}
const _hoisted_48 = { class: "footer-btn" }
const _hoisted_49 = {
  key: 0,
  class: "remote-form"
}
const _hoisted_50 = { class: "row cm-ui-mt20" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hl" }, "*", -1))
const _hoisted_52 = { class: "row cm-ui-mt20" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hl" }, "*", -1))
const _hoisted_54 = {
  class: "row cm-ui-mt20",
  style: {"flex-direction":"column"}
}
const _hoisted_55 = { class: "setting-content cm-ui-mt15" }
const _hoisted_56 = {
  class: "row",
  style: {"width":"340px"}
}
const _hoisted_57 = { class: "s" }
const _hoisted_58 = { class: "cm-ui-mr10" }
const _hoisted_59 = { class: "s" }
const _hoisted_60 = { class: "cm-ui-mr10" }
const _hoisted_61 = {
  class: "row cm-ui-mt10",
  style: {"width":"340px"}
}
const _hoisted_62 = { class: "s" }
const _hoisted_63 = { class: "cm-ui-mr10" }
const _hoisted_64 = { class: "s" }
const _hoisted_65 = { class: "cm-ui-mr10" }
const _hoisted_66 = {
  key: 1,
  class: "assist-status"
}
const _hoisted_67 = {
  key: 0,
  class: "yellow-txt cm-ui-ml10"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_69 = { class: "green-txt cm-ui-ml10" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_71 = { class: "green-txt cm-ui-ml10" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_73 = { class: "red-txt cm-ui-ml10" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_75 = { class: "green-txt cm-ui-ml10" }
const _hoisted_76 = {
  key: 2,
  class: "footer-btn"
}
const _hoisted_77 = {
  key: 0,
  class: "remote-form"
}
const _hoisted_78 = {
  key: 1,
  class: "assist-status"
}
const _hoisted_79 = {
  key: 0,
  class: "yellow-txt cm-ui-ml10"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_81 = { class: "green-txt cm-ui-ml10" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_83 = { class: "green-txt cm-ui-ml10" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_85 = { class: "red-txt cm-ui-ml10" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "terminal-icon cm-ui-mr10" }, null, -1))
const _hoisted_87 = { class: "green-txt cm-ui-ml10" }
const _hoisted_88 = {
  key: 2,
  class: "footer-btn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_DetailsSubscribeBar = _resolveComponent("DetailsSubscribeBar")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_VncPassword = _resolveComponent("VncPassword")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    modelValue: _ctx.modalVisible,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalVisible) = $event)),
    "close-on-click-modal": false,
    width: 1000,
    "destroy-on-close": "",
    onClosed: _ctx.handleClose
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('groupClient.remoteOp')), 1),
        _createVNode(_component_CmSvgIcon, { name: "assets/icons/vip-marker" })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DetailsSubscribeBar, {
        class: "cm-ui-mb10",
        "normal-permission-key": _ctx.terminalInfo.system_type !== _ctx.TerminalType.linux ? _ctx.ModulePermissionKey[_ctx.AreaType.normal] : undefined,
        "linux-permission-key": _ctx.terminalInfo.system_type === _ctx.TerminalType.linux ? _ctx.ModulePermissionKey[_ctx.AreaType.linux] : undefined,
        "auth-status": _ctx.getAuthByList(_ctx.deviceInfo.auth_status, _ctx.ModulePermissionKey[_ctx.terminalInfo.area_type]),
        "device-id": _ctx.terminalInfo.device_id,
        onAuthSuccess: _ctx.handleAuthSuccess
      }, null, 8, ["normal-permission-key", "linux-permission-key", "auth-status", "device-id", "onAuthSuccess"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('groupClient.remoteAssistLabelComputerName')), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.deviceInfo?.computer_name || ''), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('groupClient.remoteAssistLabelRegisterUserName')), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.deviceInfo?.user_mark || ''), 1)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["banner-box cm-ui-mb15 cm-ui-mt15", { 'remote-login': _ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_LOGIN}])
        }, [
          (_ctx.isUseVnc)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerThirdPartyWarn')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistHttpsLinePrefix')), 1),
                  _createElementVNode("span", {
                    class: "cm-link-light underline",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.httpsRedirect && _ctx.httpsRedirect(...args)))
                  }, "https"),
                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistHttpsLineSuffix')), 1)
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerBrowserSuggest')), 1)
              ], 64))
            : (_ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_ASSIST && !_ctx.isUseVnc)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerMasterInstallPrefix')), 1),
                    _createElementVNode("a", {
                      class: "cm-link-light underline",
                      href: _ctx.REMOTEASSISTSETUP,
                      type: "primary",
                      target: "_blank"
                    }, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerMasterInstallLink', { clientName: _ctx.brandConfig.client_name })), 9, _hoisted_15)
                  ]),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerThirdPartyWarn')), 1)
                ], 64))
              : (_ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_LOGIN && !_ctx.isUseVnc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerThirdPartyWarn')), 1))
                : (_ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_SSH)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerThirdPartyWarn')), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistHttpsLinePrefix')), 1),
                        _createElementVNode("span", {
                          class: "cm-link-light underline",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.httpsRedirect && _ctx.httpsRedirect(...args)))
                        }, "https"),
                        _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistHttpsLineSuffix')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('groupClient.remoteAssistBannerBrowserSuggest')), 1)
                    ], 64))
                  : _createCommentVNode("", true)
        ], 2),
        (Object.values(_ctx.errorMap).find(v => v))
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_ctx.errorMap.popupBlocked)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistErrorPopupBlocked')), 1),
                    _createElementVNode("span", {
                      class: "cm-link-light underline",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openWebWindow && _ctx.openWebWindow(...args)))
                    }, _toDisplayString(_ctx.$t('groupClient.remoteAssistErrorPopupOpenLink')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.errorMap.needHttps)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistErrorNeedHttps')), 1),
                    _createElementVNode("span", {
                      class: "cm-link-light underline",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.httpsRedirect && _ctx.httpsRedirect(...args)))
                    }, "https"),
                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistErrorNeedHttpsSuffix')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.errorMap.browserVersion)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('groupClient.remoteAssistErrorBrowserOutdated')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_ASSIST && _ctx.state !== _ctx.REMOTE_STATE.IDLE && !_ctx.isUseVnc)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistDialogOpenAppPrefix')), 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('groupClient.remoteAssistDialogOpenAppStrong')), 1),
                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistDialogOpenAppSuffix', { clientName: _ctx.brandConfig.client_name })), 1)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistDialogMisclickPrefix')), 1),
                _createVNode(_component_el_link, {
                  type: "primary",
                  href: _ctx.applicationUrl
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistDialogRestartLink')), 1)
                  ]),
                  _: 1
                }, 8, ["href"]),
                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistDialogRestartSuffix', { clientName: _ctx.brandConfig.client_name })), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistDialogNoPromptPrefix')), 1),
                _createVNode(_component_el_link, {
                  href: _ctx.REMOTEASSISTSETUP,
                  type: "primary",
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistDialogDownloadInstall', { clientName: _ctx.brandConfig.client_name })), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.state === _ctx.REMOTE_STATE.IDLE)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.remoteTypeShow, (card, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: card.type,
                  class: _normalizeClass(["assist-select-card", { active: _ctx.assistType === card.type, disabled: card.disableText }]),
                  onClick: ($event: any) => (_ctx.selectAssistType(card))
                }, [
                  (_ctx.assistType === card.type)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_tooltip, {
                    disabled: !card.disableText,
                    effect: "light",
                    content: card.disableText,
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("img", {
                          style: {"width":"76px"},
                          src: card.icon,
                          alt: card.title
                        }, null, 8, _hoisted_35),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("span", _hoisted_38, _toDisplayString(card.title), 1),
                            _createVNode(_component_CmSvgIcon, {
                              name: "assets/icons/vip-marker",
                              style: {"margin-top":"-2px"}
                            })
                          ]),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(card.desc), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["disabled", "content"])
                ], 10, _hoisted_30))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_ASSIST)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusControlledTitle')) + " ", 1),
                (_ctx.state === _ctx.REMOTE_STATE.UNINITIALIZED)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusFetching')), 1))
                  : (_ctx.state === _ctx.REMOTE_STATE.IDLE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusNormal')), 1))
                    : (_ctx.state === _ctx.REMOTE_STATE.WAITING)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createVNode(_component_CmSvgIcon, {
                            class: "circle-loading",
                            name: "views/dashboard/group/client/modals/_images/yellow-loading",
                            monochrome: "",
                            size: 24
                          }),
                          _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistStatusWaitingTerminal')), 1)
                        ]))
                      : (_ctx.state === _ctx.REMOTE_STATE.READY)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusReadyWaitingConn')), 1))
                        : (_ctx.state === _ctx.REMOTE_STATE.CONNECTING)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusConnecting')), 1))
                          : (_ctx.state === _ctx.REMOTE_STATE.OTHERS_CONNECTING)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusOthersConnecting')), 1))
                            : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_48, [
                (_ctx.state === _ctx.REMOTE_STATE.IDLE)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      disabled: _ctx.disabledConnect,
                      icon: "el-icon-connection",
                      size: "medium",
                      onClick: _ctx.turnOnConnect
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnConnect')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                ([_ctx.REMOTE_STATE.READY, _ctx.REMOTE_STATE.CONNECTING].includes(_ctx.state))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      loading: _ctx.endLoading,
                      type: "primary",
                      size: "medium",
                      style: {"display":"flex"},
                      onClick: _ctx.turnOffConnect
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CmSvgIcon, {
                          class: "icon-disconnect",
                          name: "views/dashboard/group/client/modals/_images/disconnect",
                          color: "#fff",
                          size: 16
                        }),
                        _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnEnd')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          : (_ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_LOGIN)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_ctx.state === _ctx.REMOTE_STATE.IDLE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      (_ctx.isUseVnc)
                        ? (_openBlock(), _createBlock(_component_VncPassword, {
                            key: 0,
                            modelValue: _ctx.login.password,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.login.password) = $event)),
                            onKeydown: _ctx.handleRemoteLoginConnect
                          }, null, 8, ["modelValue", "onKeydown"]))
                        : _createCommentVNode("", true),
                      (!_ctx.isUseVnc)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("h3", null, _toDisplayString(_ctx.$t('groupClient.remoteAssistLoginHeading', { computerName: _ctx.deviceInfo?.computer_name || '' })), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('groupClient.remoteAssistLoginSecurityNote')), 1),
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("label", null, [
                                _hoisted_51,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('groupClient.remoteAssistFieldUsername')), 1)
                              ]),
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.login.username,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.login.username) = $event)),
                                size: "medium",
                                placeholder: _ctx.$t('groupClient.remoteAssistPhLoginUsername'),
                                style: {"width":"700px"},
                                onKeydown: _withKeys(_ctx.handleRemoteLoginConnect, ["enter"])
                              }, null, 8, ["modelValue", "placeholder", "onKeydown"])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("label", null, [
                                _hoisted_53,
                                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('groupClient.remoteAssistFieldPassword')), 1)
                              ]),
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.login.password,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.login.password) = $event)),
                                autocomplete: "new-password",
                                size: "medium",
                                placeholder: _ctx.$t('groupClient.remoteAssistPhLoginPassword', { clientName: _ctx.brandConfig.client_name }),
                                "show-password": "",
                                style: {"width":"700px"},
                                onKeydown: _withKeys(_ctx.handleRemoteLoginConnect, ["enter"])
                              }, null, 8, ["modelValue", "placeholder", "onKeydown"])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["setting-title", { setting: _ctx.definitionSetting }]),
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDefinitionSetting && _ctx.handleDefinitionSetting(...args)))
                              }, _toDisplayString(_ctx.$t('groupClient.remoteAssistDefinitionTitle')), 3),
                              _withDirectives(_createElementVNode("div", null, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t('groupClient.remoteAssistDefinitionPoorNetwork')), 1),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('groupClient.remoteAssistColorDepth')), 1),
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.login.colorDepth,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.login.colorDepth) = $event)),
                                        style: {"width":"120px"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorDepthKeys, (key) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: key,
                                              label: _ctx.colorDepthList[Number(key)],
                                              value: Number(key)
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t('groupClient.remoteAssistRenderTheming')), 1),
                                      _createVNode(_component_el_switch, {
                                        modelValue: _ctx.login.enableTheming,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.login.enableTheming) = $event))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("div", _hoisted_62, [
                                      _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('groupClient.remoteAssistRenderWallpaper')), 1),
                                      _createVNode(_component_el_switch, {
                                        modelValue: _ctx.login.enableWallpaper,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.login.enableWallpaper) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('groupClient.remoteAssistWindowDragAnim')), 1),
                                      _createVNode(_component_el_switch, {
                                        modelValue: _ctx.login.enableFullWindowDrag,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.login.enableFullWindowDrag) = $event))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ])
                              ], 512), [
                                [_vShow, _ctx.definitionSetting]
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.state !== _ctx.REMOTE_STATE.IDLE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                        (_ctx.state === _ctx.REMOTE_STATE.WAITING)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                              _createVNode(_component_CmSvgIcon, {
                                class: "circle-loading",
                                name: "views/dashboard/group/client/modals/_images/yellow-loading",
                                monochrome: "",
                                size: 24
                              }),
                              _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistStatusPreparingLogin')), 1)
                            ]))
                          : (_ctx.state === _ctx.REMOTE_STATE.READY)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_68,
                                _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusReadyWaitingConn')), 1)
                              ], 64))
                            : (_ctx.state === _ctx.REMOTE_STATE.CONNECTING)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _hoisted_70,
                                  _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusTerminalConnecting')), 1)
                                ], 64))
                              : (_ctx.state === _ctx.REMOTE_STATE.CAN_NOT_CONNECT)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _hoisted_72,
                                    _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusCannotConnect')), 1)
                                  ], 64))
                                : (_ctx.state === _ctx.REMOTE_STATE.OTHERS_CONNECTING)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _hoisted_74,
                                      _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusOthersConnecting')), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                (_ctx.userInfo.is_account_user || _ctx.userInfo.vnc_password === _ctx.VncPdType.alreadySet || !_ctx.isUseVnc)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      (_ctx.state === _ctx.REMOTE_STATE.IDLE)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            icon: "el-icon-connection",
                            size: "medium",
                            disabled: (!_ctx.login.username && !_ctx.isUseVnc) || !_ctx.login.password || _ctx.disabledConnect,
                            onClick: _ctx.handleRemoteLoginConnect
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnConnect')), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : ([_ctx.REMOTE_STATE.READY, _ctx.REMOTE_STATE.CONNECTING].includes(_ctx.state))
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              loading: _ctx.endLoading,
                              type: "primary",
                              size: "medium",
                              style: {"display":"flex"},
                              onClick: _ctx.turnOffLoginConnect
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CmSvgIcon, {
                                  class: "icon-disconnect",
                                  name: "views/dashboard/group/client/modals/_images/disconnect",
                                  color: "#fff",
                                  size: 16
                                }),
                                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnEnd')), 1)
                              ]),
                              _: 1
                            }, 8, ["loading", "onClick"]))
                          : (_ctx.state === _ctx.REMOTE_STATE.CAN_NOT_CONNECT)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 2,
                                type: "primary",
                                size: "medium",
                                onClick: _ctx.turnOffLoginConnect
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnClose')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.assistType === _ctx.REMOTE_TYPE.REMOTE_SSH)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_ctx.state === _ctx.REMOTE_STATE.IDLE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                        _createVNode(_component_VncPassword, {
                          modelValue: _ctx.login.password,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.login.password) = $event)),
                          onKeydown: _ctx.handleSshConnect
                        }, null, 8, ["modelValue", "onKeydown"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state !== _ctx.REMOTE_STATE.IDLE)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                        (_ctx.state === _ctx.REMOTE_STATE.WAITING)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                              _createVNode(_component_CmSvgIcon, {
                                class: "circle-loading",
                                name: "views/dashboard/group/client/modals/_images/yellow-loading",
                                monochrome: "",
                                size: 24
                              }),
                              _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistStatusPreparingLogin')), 1)
                            ]))
                          : (_ctx.state === _ctx.REMOTE_STATE.READY)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_80,
                                _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusReadyWaitingConn')), 1)
                              ], 64))
                            : (_ctx.state === _ctx.REMOTE_STATE.CONNECTING)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _hoisted_82,
                                  _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusTerminalConnecting')), 1)
                                ], 64))
                              : (_ctx.state === _ctx.REMOTE_STATE.CAN_NOT_CONNECT)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _hoisted_84,
                                    _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusCannotConnect')), 1)
                                  ], 64))
                                : (_ctx.state === _ctx.REMOTE_STATE.OTHERS_CONNECTING)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _hoisted_86,
                                      _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.$t('groupClient.remoteAssistStatusOthersConnecting')), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.userInfo.is_account_user || _ctx.userInfo.vnc_password === _ctx.VncPdType.alreadySet)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        (_ctx.state === _ctx.REMOTE_STATE.IDLE)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              icon: "el-icon-connection",
                              size: "medium",
                              disabled: !_ctx.login.password || _ctx.disabledConnect,
                              onClick: _ctx.handleSshConnect
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnConnect')), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "onClick"]))
                          : ([_ctx.REMOTE_STATE.READY, _ctx.REMOTE_STATE.CONNECTING].includes(_ctx.state))
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                loading: _ctx.endLoading,
                                type: "primary",
                                size: "medium",
                                style: {"display":"flex"},
                                onClick: _ctx.turnOffSshConnect
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CmSvgIcon, {
                                    class: "icon-disconnect",
                                    name: "views/dashboard/group/client/modals/_images/disconnect",
                                    color: "#fff",
                                    size: 16
                                  }),
                                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnEnd')), 1)
                                ]),
                                _: 1
                              }, 8, ["loading", "onClick"]))
                            : (_ctx.state === _ctx.REMOTE_STATE.CAN_NOT_CONNECT)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 2,
                                  type: "primary",
                                  size: "medium",
                                  onClick: _ctx.turnOffSshConnect
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteAssistBtnClose')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onClosed"]))
}